<template>
  <div class>
    <el-tabs tab-position="left">
      <el-tab-pane v-for="(item) in appData" :key="item.name" :label="item.appName">
        <role-table :tableData="item.data" :appId="item.appId" :storeType="storeType"></role-table>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import RoleTable from '../../components/RoleTable'
import { getAppAllPermission } from '@/api/user'
import { mapState } from 'vuex'
export default {
  name: 'AppAuth',
  data() {
    return {
      // tableData: [],
      storeType: 'setCurAppAuthData',
      actTab: '1',
      appData: []
    }
  },
  computed: {
    ...mapState('role', ['roleId']), // 选择的角色ID
    storeAppList() {
      return this.$store.state.user.appList
    },
    tableData() {
      return JSON.parse(JSON.stringify(this.appData))
    }
  },
  components: {
    RoleTable
  },
  mounted() {
    this.appData = JSON.parse(JSON.stringify(this.storeAppList))
    this.appData.forEach((v, i) => {
      this.showRoleAuth(v, i)
    })
  },
  methods: {
    showRoleAuth(item, index) {
      const app = item.appId
      let queryType = '0'
      const roleId = this.roleId
      if (this.roleId) {
        queryType = '1'
      }
      if (app !== 'aicc-workbench') {
        getAppAllPermission({ app, queryType, roleId })
          .then(res => {
            /* this.appData[index] = Object.assign({}, this.appData[index], {
              data: res.data
            }) */
            this.appData[index].data = res.data
            const obj = {}
            obj.appId = app
            obj.data = res.data
            this.$store.commit(`role/${this.storeType}`, obj)
          })
          .catch(() => {
          })
      }
    }
  }
}
</script>
